"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSelectBrandImgCtl = /** @class */ (function (_super) {
    __extends(DlgSelectBrandImgCtl, _super);
    function DlgSelectBrandImgCtl() {
        return _super.call(this, true) || this;
    }
    DlgSelectBrandImgCtl.prototype.ResetData = function () {
        this.DATA = {
            onSelect: null,
            dialogTitle: "",
            visible: false,
        };
    };
    DlgSelectBrandImgCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSelectBrandImgCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSelectBrandImgCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSelectBrandImgCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSelectBrandImgCtl.prototype.SetOnSelect = function (callback) {
        this.DATA.onSelect = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectBrandImgCtl.prototype, "onSelect", {
        get: function () {
            return this.DATA.onSelect;
        },
        enumerable: true,
        configurable: true
    });
    DlgSelectBrandImgCtl.prototype.SetDialogTitle = function (title) {
        this.DATA.dialogTitle = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgSelectBrandImgCtl.prototype, "dialogTitle", {
        get: function () {
            return this.DATA.dialogTitle;
        },
        enumerable: true,
        configurable: true
    });
    return DlgSelectBrandImgCtl;
}(BaseController_1.BaseController));
exports.DlgSelectBrandImgCtl = DlgSelectBrandImgCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSelectBrandImage.ts
// module id = 902
// module chunks = 0